import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Services from "./Services";
import ScrollVelocity from "../Effects/ScrollVelocity";
import SpotlightCardDemo from "./SpotlightCardDemo";
import { ThreeDMarqueeDemoSecond } from "./3DMarqueeDemo";
import InfinityBrandScroll from "./InfinityBrandScroll";
import { LogoCarouselDemo } from "./LogoCarouselDemo";
import Footer from "./Footer";
import AboutPage from "./AboutPage";
import OurTeam from "./OurTeam";
import introVideo from "../assets/loding.mp4"; 
import RentItems1 from "./RentItems1";

const Home = () => {
  const [isVideoFinished, setIsVideoFinished] = useState(false);
  const videoRef = useRef(null);

  const handleVideoEnd = () => {
    setIsVideoFinished(true);
  };

  useEffect(() => {
    // Optional: set a fallback timeout in case video fail
    const timeout = setTimeout(() => setIsVideoFinished(true), 8000);
    return () => clearTimeout(timeout);
  }, []);

  if (!isVideoFinished) {
    return (
      <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
        <video
          ref={videoRef}
          src={introVideo}
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <Hero />

      <section id="services" className="scroll-mt-16">
        <Services />
      </section>

      <ScrollVelocity
        texts={[
          <>
            <span className="uppercase">
              <span className="text-[rgba(222,222,222,0.5)]">United </span>
              <span className="text-[rgba(222,222,222,0.5)]">Events</span>
            </span>
          </>,
          <>
            <span className="uppercase">
              <span className="text-[rgba(222,222,222,0.5)]">United </span>
              <span className="text-[rgba(222,222,222,0.5)]">Events</span>
            </span>
          </>,
        ]}
        velocity={100}
        className="custom-scroll-text text-2xl sm:text-4xl md:text-5xl lg:text-6xl"
      />

      <SpotlightCardDemo />
      <ThreeDMarqueeDemoSecond />
      <RentItems1/>
      <LogoCarouselDemo />
      <InfinityBrandScroll />

      <section id="team" className="pt-32 scroll-mt-32">
        <OurTeam />
      </section>

      <section id="about" className="pt-60 scroll-mt-5">
        <AboutPage />
      </section>

    

      <Footer />
    </>
  );
};

export default Home;
